import React from 'react';
import styled from '@emotion/styled';
import { useImageUrlBuilder } from 'hooks/useImageUrlBuilder';

const Img = styled.img<{ withShadow?: boolean }>`
  ${({ withShadow }) => `
    width: 39px;
    height: 52px;
    object-fit: contain;
    ${withShadow ? `filter: drop-shadow(0 1px 3px rgba(0, 0, 0, .3));` : ''}
  `}
`;

export type TopTenBadgeVariant = 'regular' | 'golden';

const defaultVariantToImagePath: Record<TopTenBadgeVariant, string> = {
  regular: '/agents/top-agent/top-agent@2x.png',
  golden: '/agents/top-agent-gold/top-agent-gold@2x.png',
};

interface TopTenBadgeProps {
  variant?: TopTenBadgeVariant;
  withShadow?: boolean;
  variantToImagePath?: Record<TopTenBadgeVariant, string>;
}

export const TopTenBadge: React.FC<TopTenBadgeProps> = props => {
  const { variant, withShadow, variantToImagePath = defaultVariantToImagePath } = props;
  const build = useImageUrlBuilder();
  const path = variantToImagePath[variant];
  const imageUrl = path ? build(path) : '';
  return imageUrl ? <Img src={imageUrl} withShadow={withShadow} /> : null;
};
